import React from 'react';
import { createPortal } from 'react-dom';
import TS_GenerateECertificateModal from './TS_GenerateECertificateModal';

const CertificateActionHandler = ({ isOpen, onClose, application, onComplete }) => {
   // Wrap the modal in a portal to render it outside the table structure
   return (
      <>
         {isOpen && (
            <Portal>
               <TS_GenerateECertificateModal
                  isOpen={isOpen}
                  onClose={onClose}
                  application={application}
                  onComplete={onComplete}
               />
            </Portal>
         )}
      </>
   );
};

// Create a Portal component to render content outside the current DOM hierarchy
const Portal = ({ children }) => {
   const [mounted, setMounted] = React.useState(false);
   const portalRef = React.useRef(null);

   React.useEffect(() => {
      // Create a div that lives outside the main app hierarchy
      const portal = document.createElement('div');
      portal.setAttribute('data-portal', 'certificate-modal');
      document.body.appendChild(portal);
      portalRef.current = portal;
      setMounted(true);

      return () => {
         // Clean up the portal when component unmounts
         if (portalRef.current) {
            document.body.removeChild(portalRef.current);
         }
      };
   }, []);

   if (!mounted) return null;

   // Use createPortal instead of ReactDOM.createPortal
   return createPortal(children, portalRef.current);
};

export default CertificateActionHandler;
